import { useEffect, useState } from 'react';

/**
 * Bản web của apps/mobile/src/hooks/useSecondsLeft.ts.
 * Số giây còn lại tới `deadline` (ms epoch), tự cập nhật — dùng cho đếm ngược
 * hết hạn mã OTP và nút "Gửi lại mã". `maxSeconds` chặn trên, vì `now` có thể
 * cũ tới 1 nhịp ngay sau khi deadline mới được đặt (hiện 61 thay vì 60).
 */
export function useSecondsLeft(deadline: number | null, maxSeconds: number): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (deadline === null) return;
    const id = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(id);
  }, [deadline]);

  if (deadline === null) return 0;
  return Math.min(maxSeconds, Math.max(0, Math.ceil((deadline - now) / 1000)));
}
